import View from './view';
export const PollQuestion = View;
